var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A9A7A7",
    fillRule: "evenodd",
    d: "M3.6 2.40002C4.48366 2.40002 5.2 3.11637 5.2 4.00002C5.2 4.88368 4.48366 5.60002 3.6 5.60002C2.71634 5.60002 2 4.88368 2 4.00002C2 3.11637 2.71634 2.40002 3.6 2.40002ZM6.12187 4C6.12187 3.64281 6 3.28 6 3.28H14V4.72L6 4.7144C6 4.7144 6.12187 4.3572 6.12187 4ZM10 7.28C10 7.28 9.87813 7.64281 9.87813 8C9.87813 8.3572 10 8.7144 10 8.7144L2 8.72001V7.28H10ZM12.4 6.40002C11.5163 6.40002 10.8 7.11637 10.8 8.00002C10.8 8.88368 11.5163 9.60002 12.4 9.60002C13.2837 9.60002 14 8.88368 14 8.00002C14 7.11637 13.2837 6.40002 12.4 6.40002ZM6 11.28C6 11.28 6.12187 11.6428 6.12187 12C6.12187 12.3572 6 12.7144 6 12.7144L14 12.72V11.28H6ZM3.6 10.4C4.48366 10.4 5.2 11.1164 5.2 12C5.2 12.8837 4.48366 13.6 3.6 13.6C2.71634 13.6 2 12.8837 2 12C2 11.1164 2.71634 10.4 3.6 10.4Z",
    clipRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.f92384423b17c98888202db464d75741.svg";
export { ForwardRef as ReactComponent };